import React from "react";
import { Redirect, RouteProps } from "react-router";
import { Route } from "react-router-dom";
import { Routes } from "../constants";
import { useAuth } from "../contexts/AuthContext";

const PublicRoute = ({ component, ...routerProps }: RouteProps) => {
  const Component = component as React.ElementType;
  const { currentUser, isCurrentUserAdmin } = useAuth();
  const isAdmin = isCurrentUserAdmin();
  return !currentUser?.emailVerified ? (
    <Route {...routerProps} render={(props) => <Component {...props} />} />
  ) : (
    <Redirect
      to={isAdmin ? Routes.ADMIN_NOTIFICATIONS : Routes.MANAGE_COLLECTIONS}
    />
  );
};

export default PublicRoute;
